import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Typography from 'Components/UI/Typography';

const styles = () => ({
  root: {},
  label: {
  },
});

const EmergencyFundOutcomeExpenseReviewStepLayout = ({
  className,
  classes,
}) => {
  const { resource } = useMetaLayoutContext();

  const adjustedAverageExpense = parseFloat(resource.attr('averageExpense')) + parseFloat(resource.attr('averageExpenseOverride')) || 0;

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaField attr="averageExpense" />
      <MetaField attr="averageExpenseOverride" />
      <Typography variant="h6">Adjusted Expenses</Typography>
      <Typography className={classes.label} variant="h2">${adjustedAverageExpense}</Typography>
    </Box>
  );
};

EmergencyFundOutcomeExpenseReviewStepLayout.defaultProps = {
  className: '',
};

EmergencyFundOutcomeExpenseReviewStepLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmergencyFundOutcomeExpenseReviewStepLayout);
